/* eslint-disable import/prefer-default-export */
import { FILTER_KEYS, FilterKey } from './filterConstants';

/**
 * Type representing the possible custom mapping values for boolean filters
 */
type BooleanFilterCustomMappingValue = boolean | string | number;

/**
 * When toggled on, boolean filters will append a query param of `${filterKey}=true` by default.
 * Some boolean filters require a value other than "true" in order to perform the correct filter in ES.
 *
 * For instance, when the `inNetworkPreferred` filter is toggled on, the proper
 * parameter to add to the ES query is `curated_out=false`, not `curated_out=true`.
 * The filter "key" value of `curated_out` is from `filterKeyMap.ts`
 */
export const booleanFilterCustomMappings: Partial<
  Record<FilterKey, BooleanFilterCustomMappingValue>
> = {
  inNetworkPreferred: false,
  healthConnectPlan: 'health_connect',
  preferredGroup: 1,
  [FILTER_KEYS.TIERING]: '1',
  [FILTER_KEYS.HEALTH_PLAN_TIER]: 1,
};
